var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69096 2.14551C5.08376 2.14551 2.14551 5.08376 2.14551 8.69096C2.14551 12.2982 5.08376 15.2364 8.69096 15.2364C10.2596 15.2364 11.7002 14.6794 12.8292 13.7547L16.7373 17.6628C16.7976 17.7257 16.8698 17.7758 16.9498 17.8104C17.0297 17.8449 17.1157 17.8632 17.2028 17.864C17.2899 17.8649 17.3763 17.8484 17.4569 17.8155C17.5375 17.7826 17.6108 17.7339 17.6724 17.6724C17.7339 17.6108 17.7826 17.5375 17.8155 17.4569C17.8484 17.3763 17.8649 17.2899 17.864 17.2028C17.8632 17.1157 17.8449 17.0297 17.8104 16.9498C17.7758 16.8698 17.7257 16.7976 17.6628 16.7373L13.7547 12.8292C14.6794 11.7002 15.2364 10.2596 15.2364 8.69096C15.2364 5.08376 12.2982 2.14551 8.69096 2.14551ZM8.69096 3.4546C11.5907 3.4546 13.9273 5.79125 13.9273 8.69096C13.9273 11.5907 11.5907 13.9273 8.69096 13.9273C5.79125 13.9273 3.4546 11.5907 3.4546 8.69096C3.4546 5.79125 5.79125 3.4546 8.69096 3.4546Z",
    fill: "#4A5056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/searchBlack.9f5b32509eddceeee58b446d8abaadc5.svg";
export { ForwardRef as ReactComponent };